<template>
    <v-container flex grid-list-lg>
        <template v-if="!smartLock">
            <smart-lock-message></smart-lock-message>
        </template>
        <v-layout row wrap v-else>
            <v-flex xs12>
                <v-toolbar color="#eee" class="elevation-0 secondary--text">
                    <v-toolbar-title>Convênios</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-slide-x-transition>
                      <v-layout justify-end v-show="searchingConvenio">
                        <v-flex xs1>
                        <v-tooltip bottom>
                          <v-btn
                            icon
                            color="info"
                            @click="carregarConvenios(true)"
                            slot="activator"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                          <span>Pesquisar</span>
                        </v-tooltip>
                      </v-flex>
                        <v-flex xs3>
                          <v-select
                          outline
                          hide-details
                          single-line
                          placeholder="Filtrar por"
                          :items="filtrosConvenio"
                          item-value="value"
                          item-text="text"
                          v-model="filtro"
                          ></v-select>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field
                            outline
                            hide-details
                            single-line
                            placeholder="Insira as informações"
                            v-model="campoPesquisa"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-slide-x-transition>
                    <v-btn
                      icon
                      color="info"
                      @click="searchingConvenio = !searchingConvenio"
                    >
                      <v-icon v-if="searchingConvenio">close</v-icon>
                      <v-icon v-else>search</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-flex>
            <v-flex xs12>
                <v-data-table
                    :headers="conveniosHeaders"
                    :items="convenios"
                    :loading="loading"
                    :pagination.sync="pagination"
                    :total-items="totalItems"
                    hide-actions
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                <template slot="headerCell" slot-scope="{ header }">
                    <span class="font-weight-light" v-text="header.text" />
                </template>
                <template slot="items" slot-scope="props">
                    <td>{{ props.item.nome_convenio }}</td>
                    <td class="text-xs-left">{{ props.item.codigo }}</td>
                    <td class="text-xs-left">{{ props.item.instituicao_representante ? props.item.instituicao_representante.nome : '' }}</td>
                    <td
                    class="text-xs-left"
                    v-html="`${props.item.instituicao_representante ? props.item.instituicao_representante.cnpj : ''}`"
                    ></td>
                    <td
                    class="text-xs-left"
                    v-html="`${props.item.instituicao_representante ? props.item.instituicao_representante.tipo : ''}`"
                    ></td>
                    <td
                    class="text-xs-left"
                    v-html="`${props.item.representante ? props.item.representante.nome + ' ' + props.item.representante.sobrenome : ''}`"
                    ></td>
                    <td class="text-xs-left">
                        <v-btn flat icon v-if="props.item.ativo" color="green lighten-2">
                            <v-icon>check_circle</v-icon>ATIVO
                        </v-btn>

                        <v-btn flat icon v-else color="error">
                            <v-icon>cancel</v-icon>INATIVO
                        </v-btn>
                    </td>
                    <td class="text-xs-right">
                        <v-tooltip lazy v-if="props.item.ativo" bottom>
                            <v-btn icon color="red" slot="activator" flat @click="ativaOuDesativarConvenio(props.item)">
                            <v-icon>close</v-icon>
                            </v-btn>Desativar convênio
                        </v-tooltip>
                        <v-tooltip lazy v-else bottom>
                            <v-btn icon flat color="green" slot="activator" @click="ativaOuDesativarConvenio(props.item)">
                            <v-icon>check</v-icon>
                            </v-btn>Ativar convênio
                        </v-tooltip>
                    </td>
                    <td>
                        <v-tooltip lazy bottom>
                        <v-btn slot="activator" flat icon color="primary" @click="abrirDetalhes(props.item)">
                            <v-icon>remove_red_eye</v-icon>
                        </v-btn> Visualizar dados do convênio
                        </v-tooltip>
                    </td>
                </template>
                </v-data-table>
                <div class="text-xs-center pt-2">
                    <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
                </div>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogDetalhes" v-if="dialogDetalhes" width="500">
            <detalhes-convenio @fechar="dialogDetalhes = false" :convenio="convenioSelecionado"/>
        </v-dialog>
    </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DetalhesConvenio from '@/components/dialogs/DetalhesConvenio'
export default {
  components: { SmartLockMessage, DetalhesConvenio },
  data () {
    return {
      campoPesquisa: '',
      filtrosConvenio: [
        { value: 'nome_convenio', text: 'Nome' },
        { value: 'codigo', text: 'Código' }
      ],
      filtro: '',
      searchingConvenio: false,
      dialogDetalhes: false,
      convenioSelecionado: null,
      primeiroCarregamento: false,
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      conveniosHeaders: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },
      { text: 'Código', sortable: false, value: 'codigo' },
      { text: 'Nome da Institução', sortable: false, value: 'nome_instituicao' },
      { text: 'CNPJ', sortable: false, value: 'cnpj' },
      { text: 'Tipo', sortable: false, value: 'tipo' },
      { text: 'Representante', sortable: false, value: 'representante' },
      { text: 'Status', sortable: false, value: 'ativo' },
      {
        sortable: false,
        align: 'right'
      },
      {
        sortable: false,
        align: 'right'
      }
      ]
    }
  },
  computed: {
    smartLock () {
      return this.$store.getters.smartLock
    },
    convenios () {
      return this.$store.getters.convenios
    },
    loading () {
      return this.$store.getters.loading
    },
    totalItems () {
      return this.$store.getters.totalItemsConvenios
    },
    headers () {
      return this.$store.getters.headers
    },
    pages () {
      if (this.pagination.rowsPerPage == null || this.totalItems == null) {
        return 0
      }

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    carregarConvenios (zerarPaginacao) {
      let filtros = {}
      if (zerarPaginacao) {
        this.pagination = {
          page: 1,
          rowsPerPage: this.pagination.rowsPerPage
        }
      }
      if (this.campoPesquisa) {
        switch (this.filtro) {
          case 'codigo':
            filtros['codigo__icontains'] = this.campoPesquisa
            break
          case 'nome_convenio':
            filtros['nome_convenio__icontains'] = this.campoPesquisa
            break
        }
      }
      this.$store.dispatch('getConvenios', { page: this.pagination.page, filtros: filtros }).then(() => {
        this.primeiroCarregamento = true
      })
    },
    ativaOuDesativarConvenio (convenio) {
      this.$store.dispatch('ativarOuDesativarConvenio', convenio.id).then(() => {
          this.carregarConvenios(false)
      })
    },
    abrirDetalhes (convenio) {
      this.convenioSelecionado = convenio
      this.dialogDetalhes = true
    }
  },
  watch: {
    pagination: {
      handler (val) {
        if (this.primeiroCarregamento) this.carregarConvenios(false)
      },
      deep: true
    }
  }
}
</script>
